export const KNOWLEDGE_BASE_SEARCH_PARAMS = 'withKnowledgeBase';
export const KNOWLEDGE_BASE_ARTICLE_SEARCH_PARAMS = 'article';
export const KNOWLEDGE_BASE_SLUG_SEARCH_PARAMS = 'slug';
